export default __webpack_public_path__ + "static/media/cert-startup-consumer.4d37af84.jpg";